import {getCssSizeValue, getFontSize, getHtmlFromRedactorField} from "@/utils/utils";
import Button from "@/components/common/Buttons/Button";
import React from "react";
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";
import Modal from "@/components/common/Modal";
import {useRouter} from "next/router";

const StyledModalContent = styled.div`
	        h2 {
            border-top: 1px solid ${({theme}) => theme.colors.antiflashWhite};
            padding-top: ${getCssSizeValue(16)};
            margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
			
            font-family: var(--font-borna);
			font-size: ${getFontSize(18, BREAKPOINTS.MOBILE)};
			line-height: ${getFontSize(25.2, BREAKPOINTS.MOBILE)};
			font-weight: ${({theme}) => theme.fontWeight.semiBold};
			@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
				font-size: ${getFontSize(18, BREAKPOINTS.TABLET)};
			}
			@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
                margin-bottom: ${getCssSizeValue(40)};
				font-size: ${getFontSize(26, BREAKPOINTS.DESKTOP)};
				line-height: ${getFontSize(46.8, BREAKPOINTS.DESKTOP)};
			}
        }
        h3 {
			font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};
			line-height: ${getFontSize(21, BREAKPOINTS.MOBILE)};
			font-weight: ${({theme}) => theme.fontWeight.bold};
			@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
				font-size: ${getFontSize(14, BREAKPOINTS.TABLET)};
				line-height: ${getFontSize(22, BREAKPOINTS.TABLET)};
			}
			@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
				font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
				line-height: ${getFontSize(32.4, BREAKPOINTS.DESKTOP)};
			}
        }
        p {
            margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
			font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};
			line-height: ${getFontSize(21, BREAKPOINTS.MOBILE)};
			font-weight: ${({theme}) => theme.fontWeight.regular};
			@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
				font-size: ${getFontSize(14, BREAKPOINTS.TABLET)};
				line-height: ${getFontSize(22, BREAKPOINTS.TABLET)};
			}
			@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
                margin-bottom: ${getCssSizeValue(32)};
				font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
				line-height: ${getFontSize(32.4, BREAKPOINTS.DESKTOP)};
			}
        }
	.scroll-content {
		max-height: 86%;
		overflow: auto;
        &::-webkit-scrollbar {
            display: none;
        }
         margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};

        @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
            margin-bottom: ${getCssSizeValue(50)};
            max-height: 82%;
        }

        h2 {
            border-top: 1px solid ${({theme}) => theme.colors.antiflashWhite};
            padding-top: ${getCssSizeValue(16)};
            margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
			
            font-family: var(--font-borna);
			font-size: ${getFontSize(18, BREAKPOINTS.MOBILE)};
			line-height: ${getFontSize(25.2, BREAKPOINTS.MOBILE)};
			font-weight: ${({theme}) => theme.fontWeight.semiBold};
			@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
				font-size: ${getFontSize(18, BREAKPOINTS.TABLET)};
			}
			@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
                margin-bottom: ${getCssSizeValue(40)};
				font-size: ${getFontSize(26, BREAKPOINTS.DESKTOP)};
				line-height: ${getFontSize(46.8, BREAKPOINTS.DESKTOP)};
			}
        }
        h3 {
			font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};
			line-height: ${getFontSize(21, BREAKPOINTS.MOBILE)};
			font-weight: ${({theme}) => theme.fontWeight.bold};
			@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
				font-size: ${getFontSize(14, BREAKPOINTS.TABLET)};
				line-height: ${getFontSize(22, BREAKPOINTS.TABLET)};
			}
			@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
				font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
				line-height: ${getFontSize(32.4, BREAKPOINTS.DESKTOP)};
			}
        }
        p {
            margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
			font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};
			line-height: ${getFontSize(21, BREAKPOINTS.MOBILE)};
			font-weight: ${({theme}) => theme.fontWeight.regular};
			@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
				font-size: ${getFontSize(14, BREAKPOINTS.TABLET)};
				line-height: ${getFontSize(22, BREAKPOINTS.TABLET)};
			}
			@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
                margin-bottom: ${getCssSizeValue(32)};
				font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
				line-height: ${getFontSize(32.4, BREAKPOINTS.DESKTOP)};
			}
        }
	}
`


export default function TextModal({
	isOpen=false,
	textContent = '',
	handleClose = () => {},
	...props
}) {
	const {locale} = useRouter();
	return (
		<Modal isOpen={isOpen} handleClose={handleClose}  {...props} >
			<StyledModalContent>
				{/*<div className='typo-strawford typo-strawford-59 scroll-content' dangerouslySetInnerHTML={getHtmlFromRedactorField(textContent)} />*/}
				<div className='typo-strawford typo-strawford-59' dangerouslySetInnerHTML={getHtmlFromRedactorField(textContent)} />
				<Button onClick={handleClose}>{locale === 'pl' ? 'Zamknij okno' : 'Close'}</Button>
			</StyledModalContent>
		</Modal>
	)
}
